import Slider from 'antd-mobile/lib/slider';
export default Slider;



// WEBPACK FOOTER //
// ./components/slider/index.tsx